<div class="toka-firma">
    <div class="toka-firma__card">

        <!-- Cargando -->
        <ng-container *ngIf="paso === 'cargando'">
            <div class="toka-firma__spinner"></div>
            <p class="toka-firma__texto">Cargando tu información…</p>
        </ng-container>

        <!-- Ya tiene convenio activo -->
        <ng-container *ngIf="paso === 'activa'">
            <h1 class="toka-firma__titulo">Tu suscripción está activa</h1>
            <p class="toka-firma__texto">
                El cobro se realiza automáticamente cada mes a través de Toka.
            </p>
            <button class="toka-firma__boton toka-firma__boton--secundario"
                    [disabled]="enviando"
                    (click)="cancelar()">
                Cancelar suscripción
            </button>
            <button class="toka-firma__enlace" (click)="irAlInicio()">Volver al inicio</button>
        </ng-container>

        <!-- Faltan los apellidos -->
        <ng-container *ngIf="paso === 'datos'">
            <h1 class="toka-firma__titulo">Confirma tus datos</h1>
            <p class="toka-firma__texto">
                Para firmar la autorización necesitamos tu nombre tal como está registrado
                en Toka.
            </p>

            <button *ngIf="!mostrarManual"
                    class="toka-firma__boton"
                    [disabled]="enviando"
                    (click)="obtenerDatosDeToka()">
                {{ enviando ? 'Consultando…' : 'Usar mis datos de Toka' }}
            </button>

            <!-- Sin esto, cualquier fallo en este paso dejaba el botón en
                 "Consultando…" sin explicar nada. -->
            <p class="toka-firma__error" *ngIf="mensajeError">{{ mensajeError }}</p>

            <button *ngIf="!mostrarManual"
                    class="toka-firma__enlace"
                    [disabled]="enviando"
                    (click)="mostrarManual = true">
                Prefiero escribirlos yo
            </button>

            <div class="toka-firma__campos" *ngIf="mostrarManual">
                <label>
                    Nombre(s)
                    <input type="text" [(ngModel)]="manual.name" autocomplete="given-name">
                </label>
                <label>
                    Apellido paterno
                    <input type="text" [(ngModel)]="manual.first_surname" autocomplete="family-name">
                </label>
                <label>
                    Apellido materno <span class="toka-firma__opcional">(opcional)</span>
                    <input type="text" [(ngModel)]="manual.second_surname">
                </label>
                <p class="toka-firma__nota">
                    Deben coincidir exactamente con los que tienes registrados en Toka.
                </p>
                <button class="toka-firma__boton"
                        [disabled]="enviando"
                        (click)="continuarConDatosManuales()">
                    {{ enviando ? 'Enviando…' : 'Continuar' }}
                </button>
            </div>
        </ng-container>

        <!-- Confirmar y pedir código -->
        <ng-container *ngIf="paso === 'confirmar'">
            <h1 class="toka-firma__titulo">{{ plan?.nombre || 'Suscripción mensual' }}</h1>

            <p class="toka-firma__precio" *ngIf="plan">
                {{ plan.precio | number:'1.2-2' }} {{ plan.moneda }} <span>al mes</span>
            </p>

            <p class="toka-firma__texto">
                Vas a autorizar el cobro automático mensual desde tu cuenta de Toka.
                Te enviaremos un código por SMS
                <ng-container *ngIf="telefono">al número {{ telefono }}</ng-container>
                para confirmarlo.
            </p>

            <a class="toka-firma__enlace-externo" href="/toka/suscripcion" target="_blank">
                Ver los detalles de la suscripción
            </a>

            <p class="toka-firma__error" *ngIf="mensajeError">{{ mensajeError }}</p>

            <button class="toka-firma__boton"
                    [disabled]="enviando"
                    (click)="solicitarCodigo(null)">
                {{ enviando ? 'Enviando…' : 'Recibir código por SMS' }}
            </button>
        </ng-container>

        <!-- Capturar el código -->
        <ng-container *ngIf="paso === 'codigo'">
            <h1 class="toka-firma__titulo">Escribe el código</h1>
            <p class="toka-firma__texto">
                Te enviamos un SMS
                <ng-container *ngIf="telefono">al {{ telefono }}</ng-container>.
            </p>

            <input class="toka-firma__codigo"
                   type="tel"
                   inputmode="numeric"
                   maxlength="10"
                   placeholder="••••"
                   [(ngModel)]="codigo">

            <p class="toka-firma__contador" *ngIf="segundosRestantes > 0">
                El código vence en {{ segundosRestantes }} s
            </p>

            <p class="toka-firma__error" *ngIf="mensajeError">{{ mensajeError }}</p>

            <button class="toka-firma__boton"
                    [disabled]="enviando"
                    (click)="firmar()">
                {{ enviando ? 'Validando…' : 'Autorizar suscripción' }}
            </button>

            <button class="toka-firma__enlace"
                    [disabled]="segundosRestantes > 0 || enviando"
                    (click)="reenviar()">
                <ng-container *ngIf="segundosRestantes > 0">
                    Reenviar código ({{ segundosRestantes }} s)
                </ng-container>
                <ng-container *ngIf="segundosRestantes === 0">Reenviar código</ng-container>
            </button>

            <p class="toka-firma__autorizado" *ngIf="montoAutorizado">
                Límite autorizado: {{ montoAutorizado | number:'1.2-2' }} MXN por cargo.
                Nunca te cobraremos por encima de ese monto.
            </p>
        </ng-container>

        <!-- Convenio firmado pero el cobro no se completó -->
        <ng-container *ngIf="paso === 'cobro'">
            <h1 class="toka-firma__titulo">Falta completar el pago</h1>
            <p class="toka-firma__texto">
                Tu autorización quedó registrada, pero el cobro de este mes no se pudo
                completar. No necesitas volver a firmar.
            </p>

            <p class="toka-firma__precio" *ngIf="plan">
                {{ plan.precio | number:'1.2-2' }} {{ plan.moneda }}
            </p>

            <p class="toka-firma__error" *ngIf="mensajeError">{{ mensajeError }}</p>

            <button class="toka-firma__boton"
                    [disabled]="enviando"
                    (click)="reintentarCobro()">
                {{ enviando ? 'Procesando…' : 'Reintentar el cobro' }}
            </button>

            <button class="toka-firma__enlace"
                    [disabled]="enviando"
                    (click)="cancelar()">
                Cancelar la suscripción
            </button>
        </ng-container>

        <!-- Listo -->
        <ng-container *ngIf="paso === 'exito'">
            <div class="toka-firma__ok">✓</div>
            <h1 class="toka-firma__titulo">¡Listo!</h1>
            <p class="toka-firma__texto">
                Tu suscripción quedó autorizada. Estamos procesando el primer cobro y en
                cuanto se confirme tendrás acceso completo.
            </p>
            <button class="toka-firma__boton" (click)="irAlInicio()">Empezar</button>
        </ng-container>

        <!-- Error de carga -->
        <ng-container *ngIf="paso === 'error'">
            <div class="toka-firma__ko">✕</div>
            <p class="toka-firma__error">{{ mensajeError }}</p>
            <button class="toka-firma__boton" (click)="irAlInicio()">Volver al inicio</button>
        </ng-container>

    </div>
</div>
